import { nothing } from "lit";

export function when<T, F = typeof nothing>(
  condition: any,
  truthy?: T,
  falsy?: F
): T | F | typeof condition | typeof nothing {
  if (arguments.length === 1) {
    return condition ? condition : nothing;
  }

  if (arguments.length === 2) {
    return condition ? truthy : nothing;
  }

  return condition ? truthy : falsy;
}
